import Button from "../../../components/shared/buttons/button";
import PatternImage from "../../../images/Pattern.svg"
import Logo from "../../../images/header-logo-captify.svg"
import './login.css'
import { getLoginUrl } from "../../../helpers/authSession";
import { useEffect, useState } from "react";
import { ensureDevAuthToken, isDevAuthSkipEnabled } from "../../../helpers/devAuth";
import Loader from "../../../components/shared/loader/Loader";

const Login = () => {
    const [devAuthLoading, setDevAuthLoading] = useState(isDevAuthSkipEnabled());

    useEffect(() => {
        if (!isDevAuthSkipEnabled()) return;
        ensureDevAuthToken().then((ok) => {
            if (ok) {
                window.location.replace("/");
                return;
            }
            setDevAuthLoading(false);
        });
    }, []);

    if (devAuthLoading) {
        return <Loader />;
    }

    return (
        <div className='login_wrapper d-flex justify-content-center align-items-center min-vh-100'>            <div className='login_form text-center position-relative'>
                <img src={PatternImage} alt="pattern" />
                <div className="login-outer">
                    <div className="text-center mb-4">
                        <img src={Logo} alt="logo" />
                    </div>
                    <div className="login-card">
                        <h1>Welcome to Captify Internal Dashboard</h1>
                        {/* <p className='pt-1 mb-3'>Not registered? <span className="hilight">Create account</span></p> */}
                        <Button
                            label="Login"
                            className="w-100"
                            onClick={() => {
                                window.location.href = getLoginUrl();
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Login;